<template>
  <div v-if="type === 'web'" class="ranking_container">
    <img src="@/assets/theme4/img/ranking_pc.png" class="ranking_bg">
    <div class="ranking_list">
      <div v-for="(item, key) in showOffGameBets" :key="key" class="ranking_box" :class="[{ 'ranking_in': rankingIn }, { 'ranking_out': rankingOut }]">
        <div>
          <div class="ranking_user">
            <div>
              <div class="ranking_id">
                {{ item.member_nickname }}
              </div>
              <div class="ranking_name">
                {{ item.game_name }}
              </div>
            </div>
            <div class="ranking_dollor">
              ${{ item.bet_result }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="ranking_container_m">
    <div class="ranking_title">
      <img src="@/assets/theme4/img/ranking_m_ing.png" class="ranking_title_img">
      <img src="@/assets/theme4/img/ranking_m_title.png" class="ranking_title_p">
    </div>
    <div class="ranking_list">
      <div v-for="(item, key) in showOffGameBets.slice(showOffGameBets.length-4, showOffGameBets.length)" :key="key" class="ranking_run" :class="[{ 'ranking_in': rankingIn }, { 'ranking_out': rankingOut }]">
        <div class="ranking_box">
          <div class="ranking_user">
            <div>
              <div class="ranking_id">
                {{ item.member_nickname }}
              </div>
              <div class="ranking_name">
                {{ item.game_name }}
              </div>
            </div>
            <div class="ranking_dollor">
              ${{ item.bet_result }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    type: {
      type: String,
      default: 'web'
    },
    parentShowOffGameBets: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showOffGameBets: [],
      rankingIn: false,
      rankingOut: false,
      runKey: 0,
      lastId: 0
    }
  },
  watch: {
    'parentShowOffGameBets': async function(to, from) {
      if (this.showOffGameBets.length === 0) {
        // 第一次
        this.showOffGameBets = JSON.parse(JSON.stringify(to))
      } else {
        if (this.checkDiff(to)) {
          this.rankingOut = true
          await this.timeout(500)
          const newTo = JSON.parse(JSON.stringify(to))
          this.handleDiff(newTo)
          this.rankingOut = false
          this.rankingin = true
          await this.timeout(500)
          this.rankingin = false
        }
      }
      // if (to.length !== 0) {
      //   if (this.lastId === 0) {
      //     this.lastId = this.parentShowOffGameBets[this.parentShowOffGameBets.length - 1].id
      //     if (this.type === 'web') {
      //       this.showOffGameBets = to.slice(0, 10)
      //     } else if (this.type === 'app') {
      //       this.showOffGameBets = to.slice(0, 4)
      //     }
      //   }
      // }
    }
  },
  created() {
    // if (this.type === 'web') {
    //   this.runKey = 9
    // } else if (this.type === 'app') {
    //   this.runKey = 4
    // }
    // setInterval(() => {
    //   if (!this.checkGoAnimate()) return
    //   else {
    //     this.lastId = this.parentShowOffGameBets[this.parentShowOffGameBets.length - 1].id
    //     if (this.runKey === 10) this.runKey = 9
    //   }
    //   this.goAnimate(this.parentShowOffGameBets[this.runKey])

    //   this.runKey++
    // }, 5000)
  },
  methods: {
    timeout(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    checkDiff(to) {
      if (this.showOffGameBets.length !== to.length) return true
      for (const i in this.showOffGameBets) {
        let check = false
        for (const j in to) {
          if (this.showOffGameBets[i].id === to[j].id) {
            check = true
            continue
          }
        }
        if (!check) return true
      }
      return false
    },
    handleDiff(to) {
      if (this.showOffGameBets.length !== to.length) {
        this.showOffGameBets = to
        return
      }
      const newRemovekeys = []
      const oriRemoveKeys = []
      for (const i in this.showOffGameBets) {
        let check = false
        for (const j in to) {
          if (this.showOffGameBets[i].id === to[j].id) {
            check = true
            newRemovekeys.push(j)
            continue
          }
        }
        if (!check) {
          oriRemoveKeys.push(i)
        }
      }
      var i = 0
      for (i = newRemovekeys.length - 1; i >= 0; i--) {
        to.splice(newRemovekeys[i], 1)
      }
      for (i = oriRemoveKeys.length - 1; i >= 0; i--) {
        this.showOffGameBets.splice(oriRemoveKeys[i], 1)
      }
      for (i in to) {
        this.showOffGameBets.push(to[i])
      }
    }
  }
}
</script>
